import type { BroadcastCheckResultDto } from '@upme/contracts';

const CHAT_TYPE_LABEL: Record<BroadcastCheckResultDto['chat']['type'], string> = {
  group: 'группа',
  supergroup: 'супергруппа',
  channel: 'канал',
};

/** Результат проверки прав бота. problems/warnings — готовые тексты бэкенда (botRightsProblems). */
export function BroadcastCheckResult({ check }: { check: BroadcastCheckResultDto }) {
  return (
    <div className="space-y-1 text-sm" data-testid="broadcast-check-result">
      <p className="text-muted-foreground">
        {check.chat.title} · {CHAT_TYPE_LABEL[check.chat.type]}
      </p>
      {check.ok ? (
        <p className="text-green-700 dark:text-green-400">Бот — администратор, права в порядке</p>
      ) : (
        <ul className="list-disc space-y-0.5 pl-5 text-destructive">
          {check.problems.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      )}
      {check.warnings.map((w) => (
        <p key={w} className="text-amber-700 dark:text-amber-400">
          {w}
        </p>
      ))}
    </div>
  );
}
